module.exports = "/images/Create your submittal log - 4.jpg";